/* import __COLOCATED_TEMPLATE__ from './project-changed-while-archived-alert.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();